import {
  applyFilters
} from './filters';

import {
  errorFetchingPlayers,
  setFootballPlayers
} from './players';

export default {
  applyFilters,
  errorFetchingPlayers,
  setFootballPlayers
};


// WEBPACK FOOTER //
// ./src/footballPlayers/actions/index.js